import React from 'react';
import update from 'immutability-helper';
import { Modal, Button, Row, Col, FormControl, Checkbox, HelpBlock } from 'react-bootstrap';
import Select from 'react-select';
import Datetime from 'react-datetime';
import Comments from '../../../../../components/Comments/Comments';
import SmallLoader from '../../../../../components/SmallLoader/index';
import { get, post } from '../../../../../shared/http/request';
import { createSpecialRecoveryAction, getIsPending } from '../../../recoveryActionsDuck';
import { connect } from 'react-redux';
import find from 'lodash/find';
import flatten from 'lodash/flatten';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import { handleRecoveryActionValidation } from '../../../../../shared/utils/handleRecoveryActionValidation';
import { bindActionCreators } from 'redux';
import { handleApiError } from '../../../../../shared/http/error';
import { formatStopLocation, formatRun } from '../../../../../shared/utils/run';

class SpecialModal extends React.Component {
    constructor(props) {
        super(props);

        const { abnormalityAnalysis, selectedAbnManifestIds } = props;

        const abnormalityManifestForManifests = flatten(
            abnormalityAnalysis.manifestGroups.map(group =>
                group.manifests.filter(
                    manifest => selectedAbnManifestIds.indexOf(manifest.abnormalityManifestId) > -1
                )
            )
        );

        this.state = {
            errors: {},
            form: {
                abnormalityId: this.props.abnormalityAnalysis.abnormalityId,
                abnormalityManifests: abnormalityManifestForManifests.map(abnManifest => ({
                    manifestId: abnManifest.manifest.manifestId,
                    abnormalityManifestId: abnManifest.abnormalityManifestId,
                })),
                arrivalDate: '',
                carrier: '',
                collectionDate: '',
                comment: '',
                fromStopId: '',
                fromLocationName: '',
                impactedRunIds: [],
                dueDate: '',
                toStopId: '',
                toLocationName: '',
                trailerIdentifier: '',
                twoWaySpecial: false,
                unloadingDate: '',
            },
            impactedRuns: [],
            impactedRunIdsTemp: [],
            logisticPartners: [],
            stops: {
                fromStops: [],
                toStops: [],
            },
            isPendingBody : false,
        };
    }

    componentDidMount() {
        this.setState({isPendingBody : true});
        get('/api/reports/logistic-partners').then(
            logisticPartners =>
                this.setState({
                    logisticPartners: logisticPartners.logisticPartnerNames.sort(),
                }),
            error => {
                console.log(
                    '[SpecialModal] Error while getting logistic partners on mount...',
                    error
                );
                this.setState({isPendingBody : false});
            }

        );

        if (
            this.state.form.abnormalityManifests &&
            this.state.form.abnormalityManifests.length > 0
        ) {
            const manifestIds = this.state.form.abnormalityManifests.map(am => am.manifestId);
            post(`/api/abnormality/special/manifests/stops`, {
                manifestIds,
            }).then(
                stops =>
                    this.setState({
                        stops: {
                            fromStops: orderBy(stops.fromStops, ['stopCode'], ['asc']),
                            toStops: orderBy(stops.toStops, ['stopCode'], ['asc']),
                        },
                        isPendingBody : false,
                    }),
                error => {
                    handleApiError(error, this.props.dispatch);
                    this.setState({isPendingBody : true});
                }
            );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { stops, form: { fromStopId, toStopId } } = this.state;

        if (
            fromStopId &&
            toStopId &&
            (prevState.form.fromStopId !== fromStopId || prevState.form.toStopId !== toStopId)
        ) {
            const fromStop = find(stops.fromStops, ['stopId', fromStopId]);
            const toStop = find(stops.toStops, ['stopId', toStopId]);
            const data = {
                from: fromStop,
                to: toStop,
                manifestIds: this.props.selectedManifestIds,
            };

            post(`/api/abnormality/manifests/impacted-runs`, data).then(
                response =>
                    this.setState({
                        impactedRuns: response.impactedRuns,
                    }),
                error => {
                    handleApiError(error, this.props.dispatch);
                }
            );
        }
    }

    handleChange = e => {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === 'fromStopId') {
            const stop = find(this.state.stops.fromStops, ['stopId', value]);
            this.setState({
                form: update(this.state.form, {
                    fromStopId: { $set: value },
                    fromLocationName: { $set: formatStopLocation(stop) },
                }),
            });
        } else if (name === 'toStopId') {
            const stop = find(this.state.stops.toStops, ['stopId', value]);
            this.setState({
                form: update(this.state.form, {
                    toStopId: { $set: value },
                    toLocationName: { $set: formatStopLocation(stop) },
                }),
            });
        } else {
            this.setState({
                form: update(this.state.form, {
                    [name]: { $set: value },
                }),
            });
        }
    };

    /*handleSelectChange = name => value => {
        this.setState(prevState => ({
            form: update(this.state.form, {
                [name]: { $set: value.split(',') },
            }),
        }));
    };*/

    handleSelectChange = name => value => {

        
        // console.log(value);
        let selectedValues = [];
        if(undefined != value && Array.isArray(value) && 0 < value.length){
            selectedValues = value.map(function(e1){
                return e1.value;
            })
        }
        console.log(selectedValues);
        this.setState({impactedRunIdsTemp:value});

        this.setState(prevState => ({
            form: update(this.state.form, {
                [name]: { $set: selectedValues },
            }),
        }));

    };
    
    handleDateChange = name => momentDate => {
        this.setState({
            form: update(this.state.form, {
                [name]: { $set: momentDate },
            }),
        });
    };

    handleConfirm = () => {
        const errors = handleRecoveryActionValidation(this.state.form);
        this.setState({ errors });

        if (Object.keys(errors).length === 0) {
            console.log(this.state.form.impactedRunIds);
            this.props.createSpecialRecoveryAction(this.state.form);
        }
    };

    render() {
        const { showModal, onClose, onHide, backdrop, isPending } = this.props;
        const { errors, form, logisticPartners, stops, impactedRuns } = this.state;
        const formattedImpactedRuns = map(impactedRuns, run => ({
            value: run.runId,
            label: formatRun(run),
        }));

        return (
            <Modal show={showModal} backdrop={backdrop} onHide={onHide} bsSize="lg">
                <Modal.Header>
                    <Modal.Title>Special</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.isPendingBody ? (
                        <div className="text-center">
                            <SmallLoader />
                        </div>
                    ) : (
                        <div>
                            <Row>
                                <Col sm={2} style={{ marginTop: 10 }}>
                                    From *
                                </Col>
                                <Col sm={4} style={{ marginTop: 5 }}>
                                    <FormControl
                                        name="fromStopId"
                                        value={form.fromStopId}
                                        onChange={this.handleChange}
                                        componentClass="select"
                                    >
                                        <option value="">Select from location</option>
                                        {stops.fromStops &&
                                            stops.fromStops.map(stop => {
                                                return (
                                                    <option key={stop.stopId} value={stop.stopId}>
                                                        {formatStopLocation(stop)}
                                                    </option>
                                                );
                                            })}
                                    </FormControl>
                                    {errors.fromLocationName && (
                                        <HelpBlock>
                                            <span className="text-danger">
                                                {errors.fromLocationName}
                                            </span>
                                        </HelpBlock>
                                    )}
                                </Col>
                                <Col sm={2} style={{ marginTop: 10 }}>
                                    To *
                                </Col>
                                <Col sm={4} style={{ marginTop: 5 }}>
                                    <FormControl
                                        name="toStopId"
                                        value={form.toStopId}
                                        onChange={this.handleChange}
                                        componentClass="select"
                                    >
                                        <option value="">Select to location</option>
                                        {stops.toStops &&
                                            stops.toStops.map(stop => {
                                                return (
                                                    <option key={stop.stopId} value={stop.stopId}>
                                                        {formatStopLocation(stop)}
                                                    </option>
                                                );
                                            })}
                                    </FormControl>
                                    {errors.toLocationName && (
                                        <HelpBlock>
                                            <span className="text-danger">
                                                {errors.toLocationName}
                                            </span>
                                        </HelpBlock>
                                    )}
                                </Col>
                            </Row>
                            <Row style={{ marginTop: 5, marginBottom: 10 }}>
                                <Col sm={2} style={{ marginTop: 10 }}>
                                    Two-way special?
                                </Col>
                                <Col sm={4}>
                                    <Checkbox
                                        name="twoWaySpecial"
                                        checked={form.twoWaySpecial}
                                        onChange={this.handleChange}
                                        inline
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={2} style={{ marginTop: 10 }}>
                                    Impacted runs *
                                </Col>
                                <Col sm={4} style={{ marginTop: 5 }}>
                                    <Select
                                        name="impactedRunIds"
                                        value={this.state.impactedRunIdsTemp}
                                        options={formattedImpactedRuns}
                                        placeholder="Select one or more runs"
                                        isMulti
                                       // simpleValue
                                       // joinValues
                                        delimiter=","
                                        onChange={this.handleSelectChange('impactedRunIds')}
                                    />
                                    {errors.impactedRunIds && (
                                        <HelpBlock>
                                            <span className="text-danger">
                                                {errors.impactedRunIds}
                                            </span>
                                        </HelpBlock>
                                    )}
                                </Col>
                            </Row>
                            <Row style={{ marginTop: 20 }}>
                                <Col sm={2} style={{ marginTop: 10 }}>
                                    Collection date
                                </Col>
                                <Col sm={4} style={{ marginTop: 5 }}>
                                    <Datetime
                                        value={form.collectionDate}
                                        onChange={this.handleDateChange('collectionDate')}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat="HH:mm"
                                        inputProps={{ maxLength: 255 }}
                                        className={errors.collectionDate && 'datetime-error'}
                                    />
                                    {errors.collectionDate && (
                                        <HelpBlock>
                                            <span className="text-danger">
                                                {errors.collectionDate}
                                            </span>
                                        </HelpBlock>
                                    )}
                                </Col>
                                <Col sm={2} style={{ marginTop: 10 }}>
                                    Carrier *
                                </Col>
                                <Col sm={4} style={{ marginTop: 5 }}>
                                    <FormControl
                                        name="carrier"
                                        value={form.carrier}
                                        onChange={this.handleChange}
                                        componentClass="select"
                                    >
                                        <option value="">Select carrier</option>
                                        {logisticPartners &&
                                            logisticPartners.map(lp => (
                                                <option key={lp} value={lp}>
                                                    {lp}
                                                </option>
                                            ))}
                                    </FormControl>
                                    {errors.carrier && (
                                        <HelpBlock>
                                            <span className="text-danger">{errors.carrier}</span>
                                        </HelpBlock>
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={2} style={{ marginTop: 10 }}>
                                    Arrival date *
                                </Col>
                                <Col sm={4} style={{ marginTop: 5 }}>
                                    <Datetime
                                        value={form.arrivalDate}
                                        onChange={this.handleDateChange('arrivalDate')}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat="HH:mm"
                                        inputProps={{ maxLength: 255 }}
                                        className={errors.arrivalDate && 'datetime-error'}
                                    />
                                    {errors.arrivalDate && (
                                        <HelpBlock>
                                            <span className="text-danger">
                                                {errors.arrivalDate}
                                            </span>
                                        </HelpBlock>
                                    )}
                                </Col>
                                <Col sm={2} style={{ marginTop: 10 }}>
                                    Trailer number
                                </Col>
                                <Col sm={4} style={{ marginTop: 5 }}>
                                    <FormControl
                                        name="trailerIdentifier"
                                        value={form.trailerIdentifier}
                                        onChange={this.handleChange}
                                        type="text"
                                        maxLength="1000"
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={2} style={{ marginTop: 10 }}>
                                    Unloading date
                                </Col>
                                <Col sm={4} style={{ marginTop: 5 }}>
                                    <Datetime
                                        value={form.unloadingDate}
                                        onChange={this.handleDateChange('unloadingDate')}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat="HH:mm"
                                        inputProps={{ maxLength: 255 }}
                                        className={errors.unloadingDate && 'datetime-error'}
                                    />
                                    {errors.unloadingDate && (
                                        <HelpBlock>
                                            <span className="text-danger">
                                                {errors.unloadingDate}
                                            </span>
                                        </HelpBlock>
                                    )}
                                </Col>
                            </Row>
                            <Row style={{ marginTop: 20 }}>
                                <Col sm={2} style={{ marginTop: 10 }}>
                                    Due date *
                                </Col>
                                <Col sm={4} style={{ marginTop: 5 }}>
                                    <Datetime
                                        value={form.dueDate}
                                        onChange={this.handleDateChange('dueDate')}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat="HH:mm"
                                        inputProps={{ maxLength: 255 }}
                                        className={errors.dueDate && 'datetime-error'}
                                    />
                                    {errors.dueDate && (
                                        <HelpBlock>
                                            <span className="text-danger">{errors.dueDate}</span>
                                        </HelpBlock>
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <div style={{ margin: 15 }}>
                                    <Comments
                                        style={{ margin: 15 }}
                                        comment={form.comment}
                                        onCommentChange={this.handleChange}
                                    />
                                </div>
                            </Row>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="success"
                        onClick={isPending ? null : this.handleConfirm}
                        disabled={isPending}
                    >
                        Create
                    </Button>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="default"
                        onClick={isPending ? null : onClose}
                        disabled={isPending}
                    >
                        Dismiss
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default connect(
    state => ({
        isPending: getIsPending(state),
    }),
    dispatch => bindActionCreators({ createSpecialRecoveryAction }, dispatch)
)(SpecialModal);
